import React from "react";
import styles from "./EmptyState.module.css";

interface Props {
  children?: React.ReactNode;
  title: string;
  text: string;
}

const EmptyState = ({ children, title, text }: Props) => {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateIcon}>🔍</div>
      <h3 className={styles.emptyStateTitle}>{title}</h3>
      <p className={styles.emptyStateText}>{text}</p>
      {children}
    </div>
  );
};

export default EmptyState;
